import { Layout } from 'antd';
import styled from 'styled-components';

export const StyledLayout = styled(Layout)`
  .content-app-layout {
    margin: 0;
    padding: 0;
    min-height: calc(100vh - 56px);
  }

  &.mobile-style {
    padding: 0;

    .content-app-layout {
      padding: 0;
    }
  }
`;
